export default __webpack_public_path__ + "static/media/LeftArrow.3e66c449.svg";